import classNames from 'classnames';
import React from 'react';

import { TextProvider } from '../TextProvider';
import { ExpectedDeliveryDateFormatter } from './ExpectedDeliveryDateFormatter';
import { PresentedDeliveryMethod } from './PresentedDeliveryMethod';

interface ExpectedDeliveryDateWithPostalCodeProps {
    postalCode: string;
    openModal: () => void;
    deliveryMethod: PresentedDeliveryMethod;
    isCooledProduct: boolean;
    cooledDeliveryInfoPage: string;
    isAnyDeliveryMethodAvailable: boolean;
}

export const ExpectedDeliveryDate = (props: ExpectedDeliveryDateWithPostalCodeProps) => {
    return (
        <>
            <div className="ExpectedDeliveryDateView__HeaderDeliveryInfoWrapper">
                <span
                    className={classNames(
                        'ExpectedDeliveryDateView__HeaderDeliveryInfo',
                        props.isCooledProduct && 'ExpectedDeliveryDateView__HeaderDeliveryInfo--CooledProduct'
                    )}
                >
                    {props.isCooledProduct ? TextProvider.expectedDeliveryDate.cooledProductDeliveryTo : TextProvider.expectedDeliveryDate.deliveryTo}{' '}
                    {props.postalCode}
                </span>
                <button
                    onClick={props.openModal}
                    className={classNames(
                        'Button Button--Small Button--Link ExpectedDeliveryDateView__LinkButton',
                        props.isCooledProduct && 'ExpectedDeliveryDateView__LinkButton--CooledProduct'
                    )}
                >
                    {TextProvider.expectedDeliveryDate.change}
                </button>
            </div>
            <div className="ExpectedDeliveryDateView__Selected">
                {!props.isAnyDeliveryMethodAvailable && props.isCooledProduct ? (
                    <div className="ExpectedDeliveryDateView__NoDeliveryWrapper">
                        <span className="ExpectedDeliveryDateView__NoDeliveryHeader">{TextProvider.expectedDeliveryDate.noDelivery}</span>
                        <span>{TextProvider.expectedDeliveryDate.noDeliveryInfo}</span>
                    </div>
                ) : (
                    <>
                        <div className="ExpectedDeliveryDateView__Header">
                            <div className="ExpectedDeliveryDateView__Details">
                                <div className="ExpectedDeliveryDateView__Logo" key={props.deliveryMethod.methodName}>
                                    <img src={props.deliveryMethod.imgUrl} />
                                </div>
                            </div>
                        </div>
                        <span className="ExpectedDeliveryDateView__Name">{props.deliveryMethod.methodName}</span>
                        <span className="ExpectedDeliveryDateView__DeliveryTime">
                            {TextProvider.expectedDeliveryDate.estimatedDelivery}:{' '}
                            <b>{ExpectedDeliveryDateFormatter.formatDate(props.deliveryMethod.expectedDeliveryDate || '')}</b>
                        </span>
                    </>
                )}
            </div>
            {props.isCooledProduct && props.cooledDeliveryInfoPage && (
                <a
                    href={props.cooledDeliveryInfoPage}
                    rel="noreferrer noopener"
                    target="_blank"
                    className="Button Button--Small Button--Link ExpectedDeliveryDateView__LinkButton ExpectedDeliveryDateView__LinkButton--CooledProduct"
                >
                    {TextProvider.expectedDeliveryDate.moreAboutCooledDelivery}
                </a>
            )}
        </>
    );
};
